module.exports = __webpack_public_path__ + "static/k12-section-5-img-52eb64a771df2f086549386022b79160.png";